<template>
    <div>
      <b-card>
        <b-row>
          <div class="col-12 mt-16">
            <b-form @submit.prevent="addUser" v-if="show">
              <div
                style="
                  background-color: rgb(97, 116, 152);
                  height: 32px;
                  border-radius: 4px;
                "
              >
                <h4
                  style="
                    color: rgb(223, 227, 238);
                    margin-left: 5px;
                    font-weight: bold;
                  "
                >
                User Management Information
                </h4>
              </div>
              <div class="row">
                <div class="col-md-4 col-12">
                <b-form-group id="input-group-2" label="Name:" label-for="first_name">
                    <b-form-input id="first_name" placeholder="Enter name"
                        v-model="first_name" disabled>
                    </b-form-input>
                </b-form-group>
            </div>
            <div class="col-md-4 col-12">
                <b-form-group id="input-group-2" label="Email:" label-for="email">
                    <b-form-input id="email" placeholder="Enter email"
                        v-model="email" disabled>
                    </b-form-input>
                </b-form-group>
            </div>
            <div class="col-md-4 col-12">
                <b-form-group id="input-group-2" label="Description:" label-for="description">
                    <b-form-input id="description" placeholder="Enter description"
                        v-model="description" disabled>
                    </b-form-input>
                </b-form-group>
            </div>
            <div class="col-md-4 col-12">
                <b-form-group id="input-group-2" label="Address:" label-for="Address">    
                    <b-form-input id="street_address" 
                        v-model="street_address" disabled> 
                    </b-form-input>    
                </b-form-group>
            </div>
            <div class="col-md-4 col-12">
                <b-form-group id="input-group-2" label="City:" label-for="city">
                    <b-form-input id="city" placeholder="Enter city"
                        v-model="city" disabled>
                    </b-form-input>
                </b-form-group>
            </div>
            <div class="col-md-4 col-12">
                <b-form-group id="input-group-2" label="State:" label-for="state">
                    <b-form-input id="state" placeholder="Enter state"
                        v-model="state" disabled>
                    </b-form-input>
                </b-form-group>
            </div>
            <div class="col-md-4 col-12">
                <b-form-group id="input-group-2" label="Country:" label-for="Country">    
                    <b-form-input id="country" 
                        v-model="country" disabled> 
                    </b-form-input>    
                </b-form-group>
            </div>
            <div class="col-md-4 col-12">
                <b-form-group id="input-group-2" label="Phone Number:" label-for="phone_number">
                    <b-form-input id="phone_number" placeholder="Enter phone number"
                        v-model="phone_number" disabled>
                    </b-form-input>    
                </b-form-group>
            </div>
            <div class="col-md-4 col-12">
                  <b-form-group id="input-group-2" label="Profile Picture:" label-for="image">
                    <div style="margin-left: 3px; margin-bottom: 15px">
                      <div v-if="image">
                      <img
                        :src="'https://wossdb.wossautoid.com/' + image"
                        alt="Picture"
                        width="100"
                        height="100"
                      />
                    </div>
                    <div v-else>
                    <span>No image available</span>
                  </div>  
                    </div>
                  </b-form-group>
                </div>
                <!-- <div class="col-md-4 col-12">
                  <b-form-group label="Modules:" label-for="modules">
                  <div v-if="modules.length > 0">
                    <ul class="list-group">
                      <li v-for="(module, index) in modules" :key="index">
                        {{ module.module_name }}
                      </li>
                    </ul>
                  </div>
                  <div v-else>
                    <span>No modules assigned.</span>
                  </div>
                </b-form-group>
              </div> -->
              </div>
              <div class="row">
                <div class="col-12 mt-16" v-for="(marketplace, index) in marketplaces" :key="marketplace.id">
                  <b-form v-if="show">
                    <div style="background-color: rgb(97, 116, 152); height: 32px; border-radius: 4px;">
                      <h4 style="color: rgb(223, 227, 238); margin-left: 5px; font-weight: bold;">
                        Marketplace Vehicels Information ({{ index + 1 }})
                      </h4>
                    </div>
                    <div class="row">
                      <div class="col-md-4 col-12">
                        <b-form-group label="Category:" label-for="category">
                          <b-form-input id="category" :value="marketplace.category.title" disabled></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-4 col-12">
                        <b-form-group label="Brand:" label-for="brand">
                          <b-form-input id="brand" :value="marketplace.brands.name" disabled></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-4 col-12">
                        <b-form-group label="Model:" label-for="model">
                          <b-form-input id="model" :value="marketplace.brand_models.title" disabled></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-4 col-12">
                        <b-form-group label="Year:" label-for="year">
                          <b-form-input id="year" :value="marketplace.year" disabled></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-4 col-12">
                        <b-form-group label="Registration Number:" label-for="registration_number">
                          <b-form-input id="registration_number" :value="marketplace.registration_number" disabled></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-4 col-12">
                        <b-form-group label="Engine Number:" label-for="engine_number">
                          <b-form-input id="engine_number" :value="marketplace.engine_number" disabled></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-4 col-12">
                        <b-form-group label="Color:" label-for="color">
                          <b-form-input id="color" :value="marketplace.color" disabled></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-4 col-12">
                        <b-form-group label="City:" label-for="city">
                          <b-form-input id="city" :value="marketplace.city" disabled></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-4 col-12">
                        <b-form-group label="Country:" label-for="country">
                          <b-form-input id="country" :value="marketplace.country" disabled></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-4 col-12">
                        <b-form-group label="Price:" label-for="price">
                          <b-form-input id="price" :value="marketplace.price" disabled></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-4 col-12">
                        <b-form-group label="Mileage:" label-for="mileage">
                          <b-form-input id="mileage" :value="marketplace.mileage || 'N/A'" disabled></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-4 col-12">
                        <b-form-group label="Fuel Type:" label-for="fuel_type">
                          <b-form-input id="fuel_type" :value="marketplace.fuel_type || 'N/A'" disabled></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-4 col-12">
                        <b-form-group label="Transmission Type:" label-for="transmission_type">
                          <b-form-input id="transmission_type" :value="marketplace.transmission_type || 'N/A'" disabled></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-4 col-12">
                        <b-form-group label="Engine Capacity:" label-for="engine_capacity">
                          <b-form-input id="engine_capacity" :value="marketplace.engine_capacity || 'N/A'" disabled></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-4 col-12">
                          <b-form-group id="input-group-2" label="Description:" label-for="description">
                              <textarea class="form-control" type="text" id="description" placeholder="Enter description"
                                  v-model="marketplace.description" disabled>
                              </textarea>
                          </b-form-group>
                      </div>
                      <div class="col-md-4 col-12">
                        <b-form-group label="Features:" label-for="features">
                          <b-form-input id="features" :value="marketplace.features || 'N/A'" disabled></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-4 col-12">
                        <b-form-group label="Assembly:" label-for="assembly">
                          <b-form-input id="assembly" :value="marketplace.assembly" disabled></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-4 col-12">
                        <b-form-group label="Status:" label-for="status">
                          <b-form-input id="status" :value="marketplace.status" disabled></b-form-input>
                        </b-form-group>
                      </div>
                    </div>
                  </b-form>
                </div>
              </div>
            </b-form>
          </div>
        </b-row>
      </b-card>
    </div>
  </template>
  
  <script>
  import {
    BRow,
    BCol,
    BCard,
    BButton,
    BForm,
    BFormGroup,
    BFormCheckboxGroup,
    BFormCheckbox,
    BFormSelect,
    BFormInput,
    BSpinner,
    BToast,
  } from "bootstrap-vue";
  import axios from "../../../axios";
  export default {
    data() {
  return {
    show: true,
    description: "",
    first_name: "",
    last_name: "",
    email: "",
    country: "",
    city: "",
    phone_number: "",
    type: "",
    image: "",
    street_address: "",
    state: "",
    editedUser: null,
    modules: [],
    marketplaces: [],
  };
},
    components: {
      BRow,
      BCol,
      BCard,
      BButton,
      BForm,
      BFormGroup,
      BFormCheckboxGroup,
      BFormCheckbox,
      BFormSelect,
      BFormInput,
      BToast,
      BSpinner,
    },
    created() {
  const userId = this.$route.params.id;
  axios
    .get(`getManagementUserById/${userId}`)
    .then((response) => {
      if (response.data && response.data.data) {
        this.editedUser = response.data.data;
        this.first_name = this.editedUser.first_name || "N/A";
        this.email = this.editedUser.email || "N/A";
        this.country = this.editedUser.country || "N/A";
        this.city = this.editedUser.city || "N/A";
        this.phone_number = this.editedUser.phone_number || "N/A";
        this.description = this.editedUser.description || "N/A";
        this.type = this.editedUser.type || "N/A";
        this.image = this.editedUser.image || "";
        this.modules = this.editedUser.modules || [];
        this.street_address = this.editedUser.street_address || "N/A";
        this.state = this.editedUser.state || "N/A";
        this.marketplaces = this.editedUser.marketplaces || [];
      } else {
        console.error("Invalid API response structure:", response);
      }
    })
    .catch((error) => {
      console.error("Error fetching user data:", error);
      if (error.response && error.response.status === 404) {
        this.$bvToast.toast("User not found.", {
          title: "Error",
          variant: "danger",
          solid: true,
          appendToast: true,
          toaster: "b-toaster-top-right",
          autoHideDelay: 5000,
        });
      } else {
        this.$bvToast.toast("An error occurred while fetching user data.", {
          title: "Error",
          variant: "danger",
          solid: true,
          appendToast: true,
          toaster: "b-toaster-top-right",
          autoHideDelay: 5000,
        });
      }
    });
},
    methods: {
        showMsgBoxOne() {
            debugger;
        },
        onSubmit(event) {
            event.preventDefault();
            alert(JSON.stringify(this.form));
           
        },
        codeClick() {
            this.codeActive = !this.codeActive;
        },

        saveOwnCar() {
            this.showModal = false;
        },
    },
  };
  </script>
  